import type { ParsedPersonalMessage } from '@module/types/centrifuge/messageTypes';
import { isPersonalAdminMessage, type PersonalAdminMessage } from '@module/types/centrifuge/personalMessageTypes';
import type { MessageHandler, MessageHandlerAction, MessageHandlerContext } from '../types';

export class PersonalAdminHandler implements MessageHandler {
  constructor(private customAction?: MessageHandlerAction<PersonalAdminMessage>) {}

  canHandle(payload: ParsedPersonalMessage): boolean {
    return isPersonalAdminMessage(payload);
  }

  handle(payload: PersonalAdminMessage, context: MessageHandlerContext): void {
    if (this.customAction === null || this.customAction === undefined) return;
    if (!context.playInfo) return;

    if (typeof this.customAction === 'function') {
      this.customAction(payload, context);
      return;
    }

    // 기본 동작
    context.setChatMessages((prev) => [...prev, payload]);
  }
}
